import { FaPlus } from 'react-icons/fa';
import cx from 'classnames';
import Section from '../../../components/Section';
import Typography from '../../../components/Typography';
import styles from './Why.module.scss';

const stats = [
  {
    label: '97%',
    text: (
      <>
        of consumers say online reviews{' '}
        <strong>influence buying decisions</strong>
      </>
    ),
  },
  {
    label: '9 out of 10',
    text: (
      <>
        consumers say reviews play a role in{' '}
        <strong>discovering a business</strong>
      </>
    ),
  },
  {
    label: '3.5x',
    text: (
      <>
        <strong>more sales</strong> on product pages with reviews than without
      </>
    ),
  },
];

const info = [
  {
    label: 'Engaging with customers',
    text: 'An opportunity to engage and show that business owners value their feedback',
  },
  {
    label: 'Improve search rankings',
    text: 'Responding to reviews can help encourage more reviews and improve overall rating which leads to a better overall search ranking',
  },
  {
    label: 'Insight into customer experience',
    text: 'Helpful for businesses to improve their products, services or customer experience and identify common issues/trends that need to be assessed',
  },
  {
    label: 'Reputation',
    text: 'Responding to negative reviews can show that a business cares about a customers thoughts',
  },
];

const why = [
  {
    label: 'AI responses',
    text: (
      <>
        <strong>Organic, original replies.</strong> Manage your brand image with
        an 'AI voice'.
      </>
    ),
    asset: require('../../../assets/reviews.png'),
  },
  {
    label: 'Free to use',
    text: (
      <>
        <strong>Now and always,</strong> Just a click away. Ready to use right
        out the gate.
      </>
    ),
    asset: require('../../../assets/rocket-maam.png'),
  },
  {
    label: 'Granular control',
    text: (
      <>
        Use human reponses for sensitive reviews, or even{' '}
        <strong>avoid keyphrases.</strong>
      </>
    ),
    asset: require('../../../assets/dashboard.png'),
  },
];

function Why() {
  return (
    <Section id="why" className={styles.container}>
      <Typography as="h2" textType="h2">
        Why reply to your reviews?
      </Typography>
      <ul className={styles.stats}>
        {stats.map((stat, idx) => (
          <li className={styles.stat} key={idx}>
            <p>
              <Typography className={styles.statLabel} textType="h2" as="span">
                {stat.label}
              </Typography>
              <Typography
                className={styles.statText}
                textType="h4"
                textWeight="normal"
                as="span"
              >
                {stat.text}
              </Typography>
            </p>
          </li>
        ))}
      </ul>
      <FaPlus className={styles.plus} />
      <ul className={styles.info}>
        {info.map((item, idx) => (
          <li key={idx}>
            <Typography textType="h4" as="h3">
              {item.label}
            </Typography>
            <Typography className={styles.infoText} textType="p1" as="p">
              {item.text}
            </Typography>
          </li>
        ))}
      </ul>
      <Typography
        className={styles.infoRef}
        textColor="text-2"
        textType="p1"
        as="p"
      >
        Source: Lin, Ying. "Online Review Statistics You Need to Know" Oberlo.
      </Typography>
      <Typography as="h2" textType="h2">
        Why choose Inform?
      </Typography>
      <ul className={styles.why}>
        {why.map((stat, idx) => (
          <li className={styles.whyItem} key={idx}>
            <p className={styles.whyContent}>
              <Typography
                className={cx(styles.whyLabel, styles.statLabel)}
                textType="h3"
                as="span"
              >
                {stat.label}
              </Typography>
              <Typography
                className={styles.statText}
                textType="h4"
                textWeight="normal"
                as="span"
              >
                {stat.text}
              </Typography>
            </p>
            <img
              width="100"
              className={styles.img}
              src={stat.asset}
              alt={stat.label}
            />
          </li>
        ))}
      </ul>
    </Section>
  );
}

Why.routeProps = {
  path: 'why',
  priority: 2,
  label: 'Why?',
};
export default Why;
